import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PopoverPlacement } from 'ngx-smart-popover';
import { Icons } from '../../../constants/icons.constants';

/**
 * @group Companies
 * @component Ineligible Tag
 *
 * @export
 * @class LsqIneligibleTagComponent
 * @property {string} placement The position of the popover
 */
@Component({
    selector: 'lsq-ineligible-tag',
    template: `
        <div
            class="ineligible-tag-component"
            popover="LSQ is unwilling to buy invoices from ineligible customers for a variety of reasons such as poor credit risk and bad payment history."
            [popoverPlacement]="placement"
        >
            <div class="ineligible-container">
                <lsq-icon [type]="icons.AlertError"></lsq-icon>
                <span class="ineligible-tag-text">Ineligible</span>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-ineligible-tag.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqIneligibleTagComponent {
    @Input() public placement: PopoverPlacement;
    public icons = Icons;
}
